import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Grid, Typography, Link } from '@material-ui/core';


const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
  description: {
    paddingTop: '2vh',
    fontSize: '16px',
    color: '#4e4e4e',
    textAlign: 'center',
    marginRight: '7vw',
    marginLeft: '7vw'
  },
  title: {
    fontWeight: 700,
    textAlign: 'center',
    fontSize: 32,
    marginTop: '8vh',
    lineHeight: 'normal'
  },
  repository: {
    textAlign: 'center',
    fontSize: 20,
    marginTop: '8vh',
    color: '#b15858'
  },
  url: {
    textAlign: 'center',
    fontSize: 20,
    marginTop: '1vh'
  }
}));

const Header = props => {
  const { className, ...rest } = props;
  const classes = useStyles();
  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Grid
        container
        justify="center"
        style={{ marginTop: '-1%' }}
      >
        <Grid item>
          <Typography className={classes.title}>LAHC applied to The Multi-Mode Resource-Constrained Multi-Project Scheduling Problem</Typography>
          <Typography className={classes.description} >7th Multidisciplinary International Conference on Scheduling: Theory and Applications</Typography>
          <Typography className={classes.description} >Prague, Czech Republic, August, 25-28, 2015</Typography>
          <Typography className={classes.description} ><b>ABSTRACT: </b>This work presents an adapted version of Late Acceptance Hill-Climbing (LAHC) for the Multi-Mode Resource-Constrained Multi-Project Scheduling Problem. The model of the problem was proposed by the MISTA 2013 Challenge. Optimizations in the code, as well as a memory diversification strategy provided a high performance parallel solver. Our preliminary experiments improved two known solutions from the instance set used in the challenge.</Typography>
          <Typography className={classes.description} ><b>ISSN: </b>2305-249X</Typography>
          <Typography className={classes.description} ><b>PAGES: </b>905-908</Typography>

          <Typography className={classes.repository}>Link</Typography>
          <Typography className={classes.url}>
            <Link
              component="a"
              href="https://rtime.felk.cvut.cz/scheduling-toolbox/mista2015.pdf#page=907"
              target="_blank"
            >
              View Publication
              </Link>
          </Typography>          
        </Grid>
      </Grid>
      <hr style={{ borderColor: '#E8E8E8', borderTop: 'none', borderLeft: 'none', borderRight: 'none', paddingTop: '3vh' }} />
    </div>
  );
};


export default Header;